import React from 'react'
import styled from 'styled-components'
import {
  cssTransition,
  ToastContainer as ToastifyToastContainer,
  CloseButton,
  IconProps,
  ToastContainerProps
} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// @ts-ignore
import { sys, ref } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'
import {
  Cross,
  IconButton,
  Warning,
  CheckSolid,
  CircleCrossOutlined,
  Info
  // @ts-ignore
} from '@netbasequid/core'

import './toast-animation.css'

const { dark, typescale } = sys

const StyledToastContainer = styled(ToastifyToastContainer)`
  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
    /* border: 1px solid red; */
    width: unset;
  }
  .Toastify__toast {
    /* border: 1px solid red; */
    border-radius: 2px;
    background-color: ${({ theme }) =>
      theme === 'light' ? dark.elevation[100].background : ref.color.gray[1150]};
    color: ${dark.text.primary};
    min-height: 46px;
    max-width: 720px;
    margin: 0 auto 16px auto;
    padding: 7px 8px 7px 16px;
    width: fit-content;
  }
  .Toastify__toast-body {
    /* border: 1px solid red; */
    line-height: ${typescale[14].lineHeight};
    font-size: ${typescale[14].size};
    padding: 0;
    margin: 0 8px 0 0;
  }
  .Toastify__progress-bar {
  }
`

const fade = cssTransition({
  enter: 'toast-fade-in',
  exit: 'toast-fade-out'
})

const CustomCloseButton: typeof CloseButton = ({ closeToast, theme }) => (
  <IconButton mode={theme} color="regular" variant="clickable" onClick={closeToast}>
    <Cross color={dark.text.primary} />
  </IconButton>
)

const getIconByType = ({ type }: IconProps) => {
  switch (type) {
    case 'success':
      return <CheckSolid color={dark.semantic.positive.default} />
    case 'warning':
      return <Warning color={dark.semantic.middle.default} />
    case 'error': // ! this is not defined in figma, can change in the future
      return <CircleCrossOutlined color={dark.semantic.negative.default} />
    case 'info': // ! this is not defined in figma, can change in the future
      return <Info color={dark.semantic.neutral.default} />
    default:
      return null
  }
}

const ToastContainer = (props: ToastContainerProps) => {
  const theme = useDisplayTheme()

  return (
    <StyledToastContainer
      position="bottom-center"
      autoClose={5000}
      newestOnTop
      hideProgressBar
      pauseOnHover
      pauseOnFocusLoss={false}
      theme={theme}
      transition={fade}
      closeButton={CustomCloseButton}
      icon={getIconByType}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
}

export default ToastContainer
